class IconSlider extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const swiperElement = this.querySelector('[data-swiper]');
      const sectionId = this.dataset.sectionId;

      if (swiperElement) {
        this.swiper = new Swiper(swiperElement, {
          // Optional parameters
          allowTouchMove: true,
          direction: 'horizontal',
          loop: false,
          spaceBetween: 0,
          slidesPerView: 2,
          speed: Number(this.dataset.speed),
          navigation: {
            nextEl: `[data-swiper-button-next="next-${sectionId}"]`,
            prevEl: `[data-swiper-button-prev="prev-${sectionId}"]`,
          },
          breakpoints: {
            768: {
              slidesPerGroup: 3,
              slidesPerView: 3,
            },
            992: {
              slidesPerGroup: 4,
              slidesPerView: 4,
            },
            1280: {
              slidesPerView: Number(this.dataset.slider_slides),
            },
          },
        });
      }
    }
  }

  customElements.define('icon-carousel', IconSlider);